import MenuItemsModal from './MenuItemsModal';

export default MenuItemsModal;
